<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>
      {{ localProduto.id ? 'Editar Produto' : 'Novo Produto' }}
    </template>
    
    <div class="modal-form-wrapper">
      <div class="form-group">
        <label>Nome do Produto</label>
        <input v-model="localProduto.nome" type="text" class="input-tatu" placeholder="Ex: Dúzia de Ovos" required>
      </div>
      
      <div class="form-row">
        <div class="form-group half">
          <label>Preço (R$)</label>
          <input v-model="precoInput" type="text" class="input-tatu" placeholder="0,00" @input="formatarPrecoInput" required>
        </div>
        <div class="form-group half">
          <label>Unidade</label>
          <input v-model="localProduto.unidade" type="text" class="input-tatu" placeholder="Ex: 12 ovos">
        </div>
      </div>
      
      <div class="form-group">
        <label>Descrição</label>
        <textarea v-model="localProduto.descricao" class="input-tatu auto-textarea" rows="2" ref="descTextarea" @input="autoResizeTextarea"></textarea>
      </div>
      
      <div class="form-group highlight-box">
        <label class="highlight-title">
          <span class="material-icons-outlined">inventory</span> Consumo de Matéria Prima
        </label>
        <select v-model="localProduto.inventario_id" class="input-tatu">
          <option :value="null">-- Não consome estoque --</option>
          <option v-for="inv in inventario" :key="inv.id" :value="inv.id">
            {{ inv.nome_recurso }} (Atual: {{ inv.quantidade }})
          </option>
        </select>
        <div v-if="localProduto.inventario_id" style="margin-top: 10px;">
          <label>Quantas unidades desconta por venda?</label>
          <input v-model.number="localProduto.unidades_consumidas" type="number" class="input-tatu" min="1">
        </div>
      </div>
      
      <div class="form-group checkbox-group">
        <label class="switch">
          <input type="checkbox" v-model="localProduto.disponivel">
          <span class="slider round"></span>
        </label>
        <span class="switch-label">Produto Disponível na Loja?</span>
      </div>
    </div>
    
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no">Cancelar</button>
      <button @click="salvar" class="modal-btn-yes" :disabled="loading">
        {{ loading ? 'Salvando...' : 'Salvar Produto' }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue';
import { AlertBus } from '@/plugins/AlertBus.js';

export default {
  name: 'ModalProdutoForm',
  components: { BaseModal },
  props: {
    produto: Object, // Se null, é criação
    inventario: Array,
    loading: Boolean
  },
  data() {
    return {
      localProduto: {
        id: null, nome: '', unidade: '', descricao: '', preco: '',
        inventario_id: null, unidades_consumidas: 1, disponivel: true
      },
      precoInput: ''
    };
  },
  mounted() {
    if (this.produto) {
      this.localProduto = { ...this.produto };
      this.precoInput = this.produto.preco ? Number(this.produto.preco).toFixed(2).replace('.', ',') : '';
    }
    this.$nextTick(() => {
      if (this.$refs.descTextarea) this.autoResizeTextarea({ target: this.$refs.descTextarea });
    });
  },
  methods: {
    formatarPrecoInput(e) { this.precoInput = e.target.value; },
    autoResizeTextarea(e) { e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + 'px'; },
    
    salvar() {
      if (!this.localProduto.nome || !this.precoInput) {
        AlertBus.$emit('show-alert', { message: 'Preencha nome e preço.', type: 'alerta' });
        return;
      }
      const precoFinal = parseFloat(this.precoInput.replace(/\./g, '').replace(',', '.'));
      if (isNaN(precoFinal)) {
        AlertBus.$emit('show-alert', { message: 'Preço inválido.', type: 'alerta' });
        return;
      }
      
      const payload = { ...this.localProduto, preco: precoFinal };
      this.$emit('save', payload);
    }
  }
};
</script>

<style scoped>
/* Copiar estilos de formulário (input-tatu, form-group, etc) */
.modal-form-wrapper { display: flex; flex-direction: column; gap: 15px; padding: 5px 0; }
.form-row { display: flex; gap: 15px; }
.form-group.half { flex: 1; }
.form-group label { display: block; margin-bottom: 6px; font-weight: 600; color: var(--text-main); font-size: 0.9rem; }
.input-tatu { width: 100%; padding: 12px; border: 1px solid var(--border-light); border-radius: 6px; background-color: var(--bg-main); color: var(--text-main); font-size: 1rem; transition: border-color 0.2s; box-sizing: border-box; }
.input-tatu:focus { outline: none; border-color: var(--color-accent); }
.auto-textarea { resize: none; overflow-y: hidden; min-height: 60px; }
.highlight-box { background-color: rgba(255, 255, 255, 0.03); border: 1px solid var(--border-light); padding: 15px; border-radius: 8px; margin-bottom: 10px; }
.highlight-title { display: flex; align-items: center; gap: 6px; color: var(--color-accent) !important; font-size: 1rem !important; margin-bottom: 4px !important; }
.checkbox-group { display: flex; align-items: center; margin: 10px 0; background-color: var(--bg-main); padding: 10px; border-radius: 6px; border: 1px solid var(--border-light); }
.switch-label { margin-left: 12px; font-weight: 600; color: var(--text-main); }
.switch { position: relative; display: inline-block; width: 46px; height: 24px; flex-shrink: 0; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; transition: .4s; }
.slider:before { position: absolute; content: ""; height: 18px; width: 18px; left: 3px; bottom: 3px; background-color: white; transition: .4s; }
input:checked + .slider { background-color: var(--color-accent); }
input:checked + .slider:before { transform: translateX(22px); }
.slider.round { border-radius: 34px; }
.slider.round:before { border-radius: 50%; }
.modal-btn-yes { background-color: #4caf50; color: white; padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; transition: all 0.2s; }
.modal-btn-yes:hover:not(:disabled) { opacity: 0.9; }
.modal-btn-yes:disabled { opacity: 0.6; cursor: not-allowed; }
.modal-btn-no { padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; transition: all 0.2s; background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light); }
.modal-btn-no:hover:not(:disabled) { background-color: var(--bg-icon-button-hover); }
</style>